import React from "react";
import { Graph } from "./BehaviourGraphs";
import { getBehaviourColourForPosition } from "@signolteam/shared/colours";

const BehaviourGraphWrapper = ({
  bvr,
  event,
  unit,
  dc,
  dcExists,
  industry,
  customerCode,
  featureCheck,
  isExample,
}) => {
  try {
    const bvrColour = getBehaviourColourForPosition(bvr?.order);

    if (!isExample && bvr?.reasons?.length > 0) {
      const error = `${event?.id} ${bvr?.behaviourAcronym} graph has failure reasons`;
      throw error;
    }
    const decoratedMetadata = event
      ? {
          ...event?.metadata,
          ocurrenceDatetime: new Date(
            event?.ocurrenceDatetime | new Date(),
          ).toISOString(),
        }
      : event;
    let acronym = bvr?.behaviourAcronym || "";
    if (!acronym.includes(":")) {
      acronym = `${bvr?.behaviourAcronym.toUpperCase()}:${bvr?.behaviourInternalTypeAcronym.toUpperCase()}`;
    }
    return (
      <div className={`w-full `}>
        <Graph
          acronym={acronym}
          metadata={decoratedMetadata}
          missingDataMsg={dc("captain__events__behaviour_graph_missing_data")}
          bvrColour={bvrColour}
          unit={unit}
          industry={industry}
          customerCode={customerCode}
          isExample={isExample}
          featureCheck={featureCheck}
          dc={dc}
          dcExists={dcExists}
        />
      </div>
    );
  } catch (err) {
    console.error(err);
    return (
      <div className="relative text-center my-6 mx-auto text-2xl">
        {dc("captain__events__behaviour_graph_missing_data")}
      </div>
    );
  }
};
export default BehaviourGraphWrapper;
